<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">緊急性の新規登録</h1>
              <div class="field">
                <label class="label">緊急性表示名</label>
                <div class="control">
                  <input class="input" type="text" placeholder="緊急性表示名" v-model="inputForm.name">
                </div>
                <div>
                  <span class="has-text-weight-bold is-size-4 has-text-danger" v-if="error.name">緊急性表示名を入力してください</span>
                </div>
              </div>
              <div class="field">
                <label class="label">アイコンイメージ</label>
                <div>
                  <img :src="inputForm.img_path" alt="アイコンイメージ" v-if="inputForm.img_path !== ''" width="64" height="64">
                </div>
                <input type="button" class="button is-link" value="アイコン表示" @click="iconShowModal = true">
                <div>
                  <span class="has-text-weight-bold is-size-4 has-text-danger" v-if="error.img_path">アイコンを選択してください</span>
                </div>
              </div>
              <button class="button is-link" v-on:click="submit">登録する</button>
              &nbsp;&nbsp;
              <router-link to="/settings/urgency">
                <span class="button is-primary">
                  <span class="icon"><i class="fa fa-backward"></i></span>&nbsp;&nbsp;戻  る
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <transition name="modal" v-if="iconShowModal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header">
                  アイコンの選択
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <div class="columns is-gapless is-multiline is-mobile">
                    <div class="column is-one-quarter" v-for="img_src in hokokuArray" v-bind:key="img_src.id">
                      <img :src="img_src" class="img_link" alt="アコンイメージ" @click="select_img(img_src)">
                    </div>
                  </div>
                  <div class="columns is-gapless is-multiline is-mobile">
                    <div class="column is-one-quarter" v-for="img_src in mituketaArray" v-bind:key="img_src.id">
                      <img :src="img_src" class="img_link" alt="アコンイメージ" @click="select_img(img_src)">
                    </div>
                  </div>
                  <div class="columns is-gapless is-multiline is-mobile">
                    <div class="column is-one-quarter" v-for="img_src in saigaiArray" v-bind:key="img_src.id">
                      <img :src="img_src" class="img_link" alt="アコンイメージ" @click="select_img(img_src)">
                    </div>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>

  </div>
</template>

<script>
import { mapState, } from 'vuex'


export default {
  data: function() {
    return {
      inputForm: {
        name: '',
        img_path: '',
      },
      error: {
        name: null,
        img_path: null,
      },
      iconShowModal: false,
      hokokuArray:[
        "static/hokoku_blue.svg",
        "static/hokoku_pink.svg",
        "static/hokoku_red.svg",
        "static/hokoku_yellow.svg",
      ],
      mituketaArray:[
        "static/mitsuketa_blue.svg",
        "static/mitsuketa_red.svg",
        "static/mitsuketa_yellow.svg",
      ],
      saigaiArray:[
        "static/saigai_black.svg",
        "static/saigai_white.svg",
        "static/saigai_yellow.svg",
      ],
    }
  },
  computed:{
    ...mapState({
      apiStatus: state => state.item.apiStatus
    })
  },
  methods: {
    select_img:function(path){
      this.inputForm.img_path = path;
      this.iconShowModal = false;
    },
    clearError(){
      //初期化
      Object.keys(this.error).forEach((key) => {
        this.$set(this.error, key, null)
      })
    },
    async submit(){
      this.clearError()
      if(this.inputForm.name === ''){
        this.$set(this.error, 'name', true)
        return false
      }else if(this.inputForm.img_path === ''){
        this.$set(this.error, 'img_path', true)
        return false
      }

      await this.$store.dispatch('item/addUrgency', this.inputForm)
      if(this.apiStatus){
        this.inputForm.name = ""
        this.inputForm.img_path = ""
        this.$swal({
          position: 'top-end',
          icon: 'success',
          title: '緊急性を追加しました。',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
};
</script>
